"use client";

import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../../dialog.js";
import { Button } from "../../button.js";
import { Info } from "lucide-react";

interface AttendeeInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const AttendeeInfoModal: React.FC<AttendeeInfoModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md bg-card border border-gray-200 shadow-xl">
        <DialogHeader className="pb-6">
          <DialogTitle className="flex items-center gap-3 text-xl font-semibold text-slate-900">
            <div className="p-2 bg-blue-50 rounded-lg">
              <Info className="h-5 w-5 text-blue-600" />
            </div>
            Adding Attendees
          </DialogTitle>
          <DialogDescription className="text-slate-600">
            Learn how to add attendees to your meeting.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="p-4 bg-card rounded-lg border border-gray-200 shadow-sm">
            <h4 className="font-medium text-slate-900 mb-3">
              How to Add Attendees:
            </h4>
            <div className="space-y-3 text-sm text-gray-700">
              <div className="flex items-start gap-2">
                <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <strong>Comma Separation:</strong> Enter multiple emails
                  separated by commas
                  <div className="text-xs text-gray-500 mt-1">
                    Example: john@example.com, jane@example.com
                  </div>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <strong>Enter Key:</strong> Press Enter to add the current
                  input to the attendee list
                  <div className="text-xs text-gray-500 mt-1">
                    Type an email and press Enter
                  </div>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <strong>Plus Button:</strong> Click the + button to add the
                  current input
                  <div className="text-xs text-gray-500 mt-1">
                    Alternative to pressing Enter
                  </div>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <strong>Quick Add:</strong> Use the team member buttons for
                  quick selection
                  <div className="text-xs text-gray-500 mt-1">
                    Click on team member names below the input
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex gap-3">
            <Button
              onClick={onClose}
              className="flex-1 bg-blue-600 hover:bg-blue-700 text-white shadow-md transition-colors"
            >
              Got it!
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
